import {
  BackgroundColorInterface,
  BackgroundImageInterface,
  BackgroundStylesInterface,
} from 'common/types/background-interfaces'
import {
  BorderType,
  ContentWidthEnum,
  PaddingType,
} from 'common/types/styleTypes'
import {
  backgroundColorCss,
  backgroundCss,
  borderCss,
  boxShadowCss,
  mobileBorderCss,
  mobileBoxShadowCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import { contentWidthValues } from 'src/shared/constants/content-width-values'
import { css, styled } from 'styled-components'

export interface WebsiteHeaderUiProps
  extends BackgroundColorInterface,
    BackgroundImageInterface {
  background?: BackgroundStylesInterface
  boxShadow?: string
  mobileBoxShadow?: string
  border?: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
}

export const WebsiteHeaderUi = styled.header<WebsiteHeaderUiProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 9;

  ${backgroundCss}
  ${backgroundColorCss}
  ${boxShadowCss}
  ${borderCss}
  ${p =>
    p.backgroundImage &&
    css`
      background-image: ${p.backgroundImage};
    `};

  ${p => p.theme.phone} {
    background-image: ${p => p.mobileBackgroundImage ?? 'none'};
    ${mobileBoxShadowCss}
    ${mobileBorderCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      background-image: ${p.mobileBackgroundImage ?? 'none'};
      ${mobileBoxShadowCss}
      ${mobileBorderCss}
    `}
`

export interface WebsiteHeaderWrapperUiProps {
  padding?: Partial<PaddingType>
  mobilePadding?: Partial<PaddingType>
  contentWidth?: ContentWidthEnum
}

export const WebsiteHeaderWrapperUi = styled.div<WebsiteHeaderWrapperUiProps>`
  min-height: 60px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  ${p =>
    p?.contentWidth &&
    css`
      max-width: ${contentWidthValues[p?.contentWidth]};
      margin: 0 auto;
      `};
    ${paddingsCss}


  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobilePaddingsCss}
    `}

`

export const WebsiteHeaderLogoWrapper = styled.div`
  order: 1;

  ${p => p.theme.phone} {
    flex-grow: 1;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      flex-grow: 1;
    `}
`
export const WebsiteHeaderMenuWrapper = styled.div`
  flex-grow: 1;
  order: 2;

  ${p => p.theme.phone} {
    flex-grow: 0;
    order: 7;
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      flex-grow: 0;
      order: 7;
    `}
`
export const WebsiteHeaderTextWrapper = styled.div`
  order: 3;
`
export const WebsiteHeaderRawHtmlWrapper = styled.div`
  order: 4;
`
export const WebsiteHeaderTwitterButtonWrapper = styled.div`
  order: 5;
`
export const WebsiteHeaderButtonWrapper = styled.div`
  order: 6;
`
export const WebsiteHeaderButtonLoginWrapper = styled.div`
  order: 7;
`
export const WebsiteHeaderButtonRegistrationWrapper = styled.div`
  order: 8;
`
export const WebsiteHeaderLanguageSwitcherWrapper = styled.div`
  order: 9;
`
